<template>
  <div class="login">
    <div class="login-container">
      <img class="login-logo" src="/assets/img/logo-light.png" />
      <p class="welcome">Bienvenido al configurador de membresías</p>
      <form action="">
        <b-form-input
          type="text"
          v-model="username"
          :state="usernameState"
          placeholder="Usuario"
        ></b-form-input>
        <b-form-input
          type="password"
          v-model="password"
          :state="passwordState"
          placeholder="Contraseña"
        ></b-form-input>
        <b-button variant="loginInput" @click="handleSubmit"
          >Ingresar</b-button
        >
        <b-alert
          :show="invalidCredentials"
          dismissible
          variant="warning"
        >
          <p>Hubo un error al iniciar sesión, por favor verifica los datos suministrados.</p>
        </b-alert>
        
      </form>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from "vuex"
import router from "../router"

function initialState() {
  return {
    section: "Login",
    loading: "",
    email: "",
    response: "",
    emailHasError: false,
    pwdHasError: false,
    invalidCredentials: false,
    inValidFeedbackRecoverPwd: false,
    validFeedbackRecoverPwd: false,
    recoverValidated: false,
    routerControl: null,
    username: "",
    password: "",
    usernameState: null,
    passwordState: null,
  };
}

export default {
  name: "Login",
  computed: {
    ...mapGetters("auth", [
      "authenticating",
      "authenticationError",
      "authenticationErrorCode"
    ])
  },
  data() {
    return initialState();
  },
  created() {
    this.routerControl = router;
  },
  methods: {
    ...mapActions('auth', ['login']),
    resetWindow: function() {
      Object.assign(this.$data, initialState());
    },
    handleSubmit() {
      
      this.usernameState = null;
      this.passwordState = null;
      this.emailHasError = false;
      this.pwdHasError = false;
      this.username = this.username ? this.username.trim() : "";
      this.invalidCredentials = false;

      if (!this.username) {
        this.usernameState = false;
        this.emailHasError = true;
      }

      if (!this.password) {
        this.passwordState = false;
        this.pwdHasError = true;
      }

      if (this.emailHasError || this.pwdHasError) {
        return false;
      }

      this.login({ username: this.username, password: this.password }).then(
        result => {

          /* eslint-disable no-console */
          console.log(result);
          /* eslint-enable no-console */

          if (!result) {
            
            this.emailHasError = true;
            this.pwdHasError = true;
            this.invalidCredentials = true;
          }
        }
      );
    },
  }
};
</script>
<style>
.form-control.is-invalid{
  background-image: unset
}
</style>